import { createCall, spellbook } from "@sdk/spellbook";

const endpoint = spellbook("/guest/tasks/{id}").GET();

export type GetGuestTaskRes = typeof endpoint.types.Res;

export async function getGuestTask({ taskId, token }: { taskId: string; token: string }) {
    const call = createCall(endpoint, (r) => fetch(r));
    const res = await call({ params: { id: taskId }, query: { token } });
    return res;
}
